import BaseEventModel from './base-event-model';

/** Represents a data model of the "Browsing Start" event. */

export class BrowsingStart extends BaseEventModel {
  constructor(
    public readonly timestamp: number,
    public readonly clientId: string,
    public readonly sessionId: string,
    public readonly merchantId: string,
    public readonly shopperCountryCode: string,
    public readonly category: string,
    public readonly cdn: string,
    public readonly pageUrl: string,
    public readonly pageTitle: string,
    public readonly screenResolution: string /* (e.g. 1280x1024) */,
    public readonly userAgent: string,
    public readonly referrer: string,
    public readonly utmSource: string,
    public readonly utmMedium: string,
    public readonly utmCampaign: string,
    public readonly utmTerm: string,
    public readonly utmContent: string,
    public readonly utmAdSet: string,
    public readonly borderfreeProperties: object,
  ) {
    super('Browsing Start', timestamp, clientId, sessionId, merchantId, shopperCountryCode, category, cdn);
  }
}
